import {
    BonusActivePanelAmountStyled,
    BonusActivePanelFlatStyled,
    BonusActivePanelOnEquityBadgeWrapperStyled,
    BonusActivePanelStyled,
} from "./styled/BonusActivePanelStyled.js";
import { InfoIcon } from "../../../../components/InfoIcon/InfoIcon.jsx";
import OnEquityBadge from "./components/OnEquityBadge/OnEquityBadge.jsx";
import { useLangContext } from "../../../../providers/LangProvider/LangProviderContext.js";

function BonusActiveItemComponent(props) {
    const {bonusValue, bonusStatus, children, infoComponent} = props;
    const {getLangPath} = useLangContext();
    return <BonusActivePanelStyled>
        <div className={'d-flex mb-1 align-items-center justify-content-between'}>
            <BonusActivePanelAmountStyled>
                ${bonusValue}
            </BonusActivePanelAmountStyled>
            {!!infoComponent && <InfoIcon children={infoComponent} title={getLangPath('bonuses.information')}/>}
        </div>
        <BonusActivePanelOnEquityBadgeWrapperStyled>
            <OnEquityBadge/>
        </BonusActivePanelOnEquityBadgeWrapperStyled>
        {children}
    </BonusActivePanelStyled>
}

function BonusActiveItemFlatComponent(props) {
    const {
        bonusValue,
        bonusStatus,
        children,
        infoComponent,
    } = props;
    const {getLangPath} = useLangContext();
    return <BonusActivePanelFlatStyled>
        <BonusActivePanelAmountStyled>
            ${bonusValue}
        </BonusActivePanelAmountStyled>
        <BonusActivePanelOnEquityBadgeWrapperStyled flat>
            <OnEquityBadge/>
        </BonusActivePanelOnEquityBadgeWrapperStyled>
        {children}
        {!!infoComponent && <InfoIcon children={infoComponent} title={getLangPath('bonuses.information')}/>}
    </BonusActivePanelFlatStyled>
}

function BonusActiveItem(props) {
    const {bonus, children, flat, infoComponent} = props;
    const Component = flat
            ? BonusActiveItemFlatComponent
            : BonusActiveItemComponent;
    const bonusValue = bonus?.credit || 0;
    return !!bonus && (
            <Component
                    bonusValue={bonusValue}
                    bonusStatus={bonus?.status}
                    infoComponent={infoComponent}
            >
                {children}
            </Component>
    )
}

export default BonusActiveItem;
